// @flow
import environment from '../environment';
import {postCreator} from '../http';

export const endpoints = Object.freeze({
  FIRE_EVENT_ANALYTICS: `${environment.apiUrl}/analytics/event`,
  PAGEVIEW_ANALYTICS: `${environment.apiUrl}/analytics/pageview`,
});

export const fireEventAnalyticsApi = postCreator(fetch, endpoints.FIRE_EVENT_ANALYTICS);
export const pageAnalyticsApi = postCreator(fetch, endpoints.PAGEVIEW_ANALYTICS);



// WEBPACK FOOTER //
// ./src/analytics/api.js